var _style, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMin3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 63",
    style: {
      enableBackground: "new 0 0 35 63"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000162315537159503211400000009477484193556595108_);}\r\n\t.st2{fill:url(#SVGID_00000035532763206368973140000003024877595348760482_);}\r\n\t.st3{fill:url(#SVGID_00000138570470656573400630000010714160537127012519_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.1096,
    y1: 2.0764,
    x2: 34.6291,
    y2: 2.0764
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001058023,
    style: {
      stopColor: "#5DB696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9963,
    style: {
      stopColor: "#4097D1"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 0.6,
    className: "st0",
    width: 34.5,
    height: 3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103974290753475992530000013339358562694357401_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.1096,
    y1: 33.1215,
    x2: 34.6291,
    y2: 33.1215
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001058023,
    style: {
      stopColor: "#5DB696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9963,
    style: {
      stopColor: "#4097D1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103974290753475992530000013339358562694357401_)"
    },
    d: "M30.7,43.9c0-5.1-2.8-9.5-7-11.8 c4.2-2.3,7-6.7,7-11.8V3.6h-3.4v16.7c0,5.5-4.5,10-10,10c-5.5,0-10-4.5-10-10V3.7H3.9v16.6c0,5.1,2.8,9.5,7,11.8 c-4.2,2.3-7,6.7-7,11.8v15.7H0.1v3h34.5v-3h-3.9V43.9z M7.3,43.9c0-5.5,4.5-10,10-10c5.5,0,10,4.5,10,10v15.7h-20V43.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044870439323002698150000013081800202182001812_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.051,
    y1: 19.5593,
    x2: 25.8615,
    y2: 19.5593
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001058023,
    style: {
      stopColor: "#5DB696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9963,
    style: {
      stopColor: "#4097D1"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 9.1,
    y: 17.8,
    style: {
      fill: "url(#SVGID_00000044870439323002698150000013081800202182001812_)"
    },
    width: 16.8,
    height: 3.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152982717641403583090000006390612653223134648_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.051,
    y1: 56.4811,
    x2: 26.1613,
    y2: 56.4811
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001058023,
    style: {
      stopColor: "#5DB696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9963,
    style: {
      stopColor: "#4097D1"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 9.1,
    y: 54.8,
    style: {
      fill: "url(#SVGID_00000152982717641403583090000006390612653223134648_)"
    },
    width: 17.1,
    height: 3.4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMin3);
export default __webpack_public_path__ + "static/media/icon_min3.6de0eee44fa126e1044aae7790f21024.svg";
export { ForwardRef as ReactComponent };